import React from 'react';
import '../general/General.css';
import { Navbar, Footer, Breadcrumbs } from "../../components/shared";


const SattrukaviValthupa = () => {
    return (
        <>
            <Navbar />
            <div className="general_parent">
                <div className="general_container">
                    <div className="general_body">
                        <Breadcrumbs /><br />

                        <br />


                    </div>
                </div>
            </div >
            <Footer /></>
    );
}
export default SattrukaviValthupa;